import {Component, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import { Router } from '@angular/router';
import { ConstService } from '../services/user-services/const.service';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: []
})
export class SidemenuComponent implements OnInit {
  @Output() sideHeader = new EventEmitter();
  @Input() userRole: string;

  constructor(
    private renderer: Renderer2,
    public constService: ConstService
  ) { }

  advancedSearchActiveClass = 'advanced-search-active';
  isClicked: boolean;

  ngOnInit(): void {
    this.isClicked = false;
  }

  public userIsAdmin = () => this.userRole === 'CedLabAdmin';
  public userHasProfessionalRole = () => ['CedLabProfessional', 'CedLabPowerUser'].includes(this.userRole);

  toggleSideHeader() {
    this.sideHeader.emit();
  }

  toggleSearch() {
    if (!document.body.classList.contains(this.advancedSearchActiveClass)) {
      this.renderer.addClass(document.body, this.advancedSearchActiveClass);
    } else {
      this.renderer.removeClass(document.body, this.advancedSearchActiveClass);
    }
  }

}
